import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function DynamicTable({ dataString }: { dataString: string }) {
    // Add validation before parsing
    if (!dataString || dataString === "undefined" || dataString.trim() === "") {
        return <p>No data available</p>;
    }

    // Parse with error handling
    let data: any[];
    try {
        data = JSON.parse(dataString);
    } catch (e) {
        console.error("Failed to parse dataString in DynamicTable:", dataString, e);
        return <p>Invalid data format</p>;
    }
    // If empty array — avoid errors
    if (!data || !Array.isArray(data) || data.length === 0) {
        return <p>No data available</p>;
    }

    // Get dynamic column names from the first object
    const columns = Object.keys(data[0]);

    // Formatter: Format numbers and percentages nicely
    // const formatValue = (value: any) => {
    //     if (typeof value === "number") {
    //         if (value < 1 && value !== 0) return (value * 100).toFixed(2) + "%"; // auto handle decimal percentages
    //         return value.toLocaleString(); // add commas for big numbers
    //     }
    //     if (value === "nan") return "Unknown";
    //     return value;
    // };

    const exportToCsv = () => {
        if (!data || !data.length) return;

        const headers = Object.keys(data[0]);
        const csvRows = [];

        // Header row
        csvRows.push(headers.join(","));

        // Data rows
        data.forEach((item: any) => {
            const row = headers
                .map(h => {
                    const val = item[h];
                    return `"${val !== undefined ? String(val).replace(/"/g, '""') : ""}"`;
                })
                .join(",");
            csvRows.push(row);
        });

        const csvString = csvRows.join("\n");

        // Create file and trigger download
        const blob = new Blob([csvString], { type: "text/csv" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "data.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
    };

    return (
        <div className="custom-card2">
            <div className="custom-card-inner">
                <div className="datatable-wrapper">
                    <div className="content-wrapper">
                        <div className="switch-section user-management-section">
                            <div className="head-btn-top">
                                <h4>Data Source</h4>
                                <div className="btn-group">
                                    <button className="btn">
                                        <span className="icon">
                                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 4H17L12 10V15L8 17V10L3 4Z"
                                                    stroke="#637381"
                                                    stroke-width="1.6"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                        Filter
                                    </button>

                                    <button className="btn" onClick={exportToCsv}>
                                        <span className="icon">
                                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 3V13"
                                                    stroke="#637381"
                                                    stroke-width="1.6"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M6 9L10 13L14 9"
                                                    stroke="#637381"
                                                    stroke-width="1.6"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M4 16H16"
                                                    stroke="#637381"
                                                    stroke-width="1.6"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                        Export
                                    </button>
                                </div>
                            </div>

                            <DataTable
                                value={data}
                                paginator
                                rows={10}
                                showGridlines
                                tableStyle={{ minWidth: "30rem", minHeight: "450px" }}
                            >
                                {columns.map((col) => (
                                    <Column
                                        key={col}
                                        field={col}
                                        header={col.replace(/_/g, " ").toUpperCase()} // "sales_percentage" → "SALES PERCENTAGE"
                                        sortable
                                        body={(rowData) => (rowData[col])}
                                    />
                                ))}
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
